exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".xs-table-with-filters .xs-server-grid {\n  padding: 10px 35px;\n}\n.xs-footer-at-custom-place {\n  height: 50px;\n  padding: 8px 32px;\n  background-color: #f0f3f8;\n}\n", ""]);

// exports
